var render, staticRenderFns
import script from "./dealer_withdrawal.vue?vue&type=script&lang=js"
export * from "./dealer_withdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47000439')) {
      api.createRecord('47000439', component.options)
    } else {
      api.reload('47000439', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/consumer/consumerScan/form/dealer_withdrawal.vue"
export default component.exports